export const ourWorkProjects = [
  {
    slug: "atlas-retail-suite",
    client: "Atlas Retail Group",
    title: "Unified Commerce Web Suite",
    type: "Web Platform",
    services: ["Product Design", "Web App Development", "AI Recommendations"],
    description:
      "A multi-store commerce platform that unifies catalog, pricing, and customer insights across channels. Built to scale for seasonal demand spikes.",
    image:
      "https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&w=1200&q=80",
    platforms: ["Web", "Android", "iOS"],
  },
  {
    slug: "pulse-health-mobile",
    client: "Pulse Health",
    title: "Patient Engagement Mobile App",
    type: "Mobile App",
    services: ["UX/UI Design", "iOS Development", "Android Development"],
    description:
      "A secure patient app for appointment management, care reminders, and telehealth access. Optimized for accessibility and compliance.",
    image:
      "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=1200&q=80",
    platforms: ["iOS", "Android"],
  },
  {
    slug: "skyline-logistics-control",
    client: "Skyline Logistics",
    title: "Operations Control Dashboard",
    type: "Web Application",
    services: ["Data Engineering", "Dashboard Development", "Automation"],
    description:
      "A real-time operations dashboard that consolidates fleet status, delivery KPIs, and exception handling into one command center.",
    image:
      "https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=1200&q=80",
    platforms: ["Web"],
  },
  {
    slug: "brightpay-wallet",
    client: "BrightPay",
    title: "Digital Wallet & Rewards",
    type: "Mobile + Web",
    services: ["Mobile Engineering", "Secure Payments", "Analytics"],
    description:
      "A wallet experience with instant transfers, rewards, and merchant offers. Designed for reliability under high transaction volumes.",
    image:
      "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=1200&q=80",
    platforms: ["Android", "iOS", "Web"],
  },
  {
    slug: "aurora-insights",
    client: "Aurora Labs",
    title: "AI Insights Portal",
    type: "AI Platform",
    services: ["ML Integration", "Data Visualization", "Cloud Infrastructure"],
    description:
      "A secure analytics portal that delivers predictive insights to business teams with configurable dashboards and role-based access.",
    image:
      "https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&w=1200&q=80",
    platforms: ["Web"],
  },
  {
    slug: "fieldops-pro",
    client: "FieldOps Pro",
    title: "Field Service Suite",
    type: "Mobile App",
    services: ["Mobile Product Strategy", "Offline Sync", "Systems Integration"],
    description:
      "A field service toolkit with offline-first task flows, asset tracking, and CRM integrations that keep crews aligned on the move.",
    image:
      "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1200&q=80",
    platforms: ["iOS", "Android", "Web"],
  },
];
